import React, { useState } from "react";
import { BiCheckCircle } from "react-icons/bi";
import { BsCircleFill, BsThreeDots, BsThreeDotsVertical } from "react-icons/bs";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import Actions from "../../../../../../../../Shared/Actions/Actions";
import Sidebar from "../../../../../../../../CommonComponets/SideBar";
import ProfileFileUpload from "../../../../../../../../Shared/UploadFile/UploadFile";
import DateInput from "../../../../../../../../Shared/DateBox";
import FloatingTextarea from "../../../../../../../../Shared/FloatingTextArea/FloatingTextArea";

const PersonalGoalCard = ({ addOpen, setAddOpen }) => {
  const [open, setOpen] = useState(false);
  const handleEdit = () => {
    setOpen(true);
  };

  const handleDelete = () => {
    Swal.fire({
      title: "",
      html: `
      <div style="text-align:center;">
        <div style="
          width:80px;
          height:80px;
          border-radius:50%;
          background:#ca2a2a60;
          display:flex;
          align-items:center;
          justify-content:center;
          margin:0 auto 15px;
        ">
          <i>
           <svg width="50" height="50" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#ff3434" />
    <path
    fill="none"
      d="M7 12l3 3 7-7"
      stroke="#fff"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
          </i>
        </div>
        <h4 style="color:#333; margin-bottom:10px;">Remove Goal?</h4>
        <p style="font-size:16px; color:#555;">
          Are you sure you want to remove
goal you selected.
        
        </p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#ff3434",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };

  const handleStatusChange = () => {
    Swal.fire({
      title: "",
      html: `
      <div style="text-align:center;">
        <div style="
          width:80px;
          height:80px;
          border-radius:50%;
          background:#e6f4ea;
          display:flex;
          align-items:center;
          justify-content:center;
          margin:0 auto 15px;
        ">
          <i>
           <svg width="50" height="50" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" fill="#4CAF50" />
    <path
    fill="none"
      d="M7 12l3 3 7-7"
      stroke="#fff"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
          </i>
        </div>

        <p style="font-size:16px; color:#555;">
          Do you want to change goal status into 
          <span style="color:#4caf50; font-weight:600;">completed</span>.
        </p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Yes, Change it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#4caf50",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };

  const imageUrl =
    "https://erp.ravbiz.in/UploadFile/PropertyFile/CustGoalFile/CustGoal_13022025145058.jpeg";

  return (
    <>
      <div className="gallery-list">
        <div className="phone-img">
          {/* Dropdown */}

          <div className="personalImgContainer position-relative">
            <Actions
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              handleStatusChange={handleStatusChange}
              third="Change to Achieved"
            />
            <img src={imageUrl} alt="goal" />
          </div>
        </div>

        {/* Details */}
        <ul className="p-2">
          <li>
            <span className="text-danger">Not Achieved</span>
          </li>

          <li>
            <strong>Date To Achieve</strong>
            <span>31-10-2024</span>
          </li>

          <li>
            <strong>Created On</strong>
            <span>31-10-2024</span>
          </li>

          <li className="d-block">
            <strong>Remark</strong>
            <ul>
              <li>Lorem Ipsum has been the isndustry's standard</li>
              <li>dummy text ever since the 1500s</li>
              <li>
                when an unknown printer took a galley of type and scrambled
              </li>
            </ul>
          </li>
        </ul>
      </div>
      {(open || addOpen) && (
        <Sidebar
          setIsFilter={() => {
            (setOpen(false), setAddOpen(false));
          }}
          heading={addOpen ? "Add Personal Goal" : "Edit Personal Goal"}
          title={addOpen ? "Add Personal Goal" : "Edit Personal Goal"}
          onClose={() => {
            (setOpen(false), setAddOpen(false));
          }}
        >
          <div className="col-12 my-3">
            <ProfileFileUpload label="Upload Goal Photo (optional)No file chosen" />
          </div>
          <div className="col-12 my-3">
            <FloatingTextarea
              label="Goal Description"
              required={true}
              placeholder="Sale of TRC in 2025"
              rows={5}
            />
          </div>
          <div className="col-12 my-2">
            <DateInput label="Goal Date" required={true} />
          </div>
          <div className="d-flex my-4">
            <button
              className="btn w-50 btn-outline-secondary me-2"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button className="btn w-50 btn-outline-success">
              Save Changes
            </button>
          </div>
        </Sidebar>
      )}
    </>
  );
};

export default PersonalGoalCard;
